import { Fragment, useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { config_url } from "../../config";
import axios from "axios";
import { toast } from "react-toastify";

function AddTag() {
  const [tag, setTag] = useState("");

  const addGroupe = () => {
    axios
      .post(`${config_url}/api/tags`, {
        tag,
      })
      .then((res) => {
        toast.success("Tag Name Is Added !!");
        setTag("");
      });
  };
  return (
    <Fragment>
      <form className="flex items-center justify-center gap-8">
        <TextField
          onChange={(e) => setTag(e.target.value)}
          id="outlined-basic"
          label="Tag Name"
          variant="outlined"
        />
        <Button variant="contained" onClick={() => addGroupe()}>
          Send
        </Button>
      </form>
    </Fragment>
  );
}

export default AddTag;
